const routes = [
  // 팝업 - 감면서비스 검색

  {
    path: 'board',
    redirect: () => ({ name: 'BoardList' }),
    children: [
      // 게시판관리 > 게시물 관리
      {
        path: 'list/:bbsId',
        name: 'BoardList',
        meta: { menu: 'board', keepAlive: true },
        component: () => import('@/pages/cmsMng/boardMng/board/BoardListContainer.vue'),
        props: (route) => ({
          bbsId: route.params.bbsId || '',
          fromBoardAttr: route.query?.fromBoardAttr || '0'
        }),
      },
      {
        path: 'detail/:bbsId/:pstId',
        name: 'BoardDetail',
        meta: { menu: 'board', keepAlive: false },
        component: () => import('@/pages/cmsMng/boardMng/board/BoardDetailContainer.vue'),
        props: (route) => ({
          bbsId: route.params.bbsId || '',
          pstId: route.params.pstId || '',
          fromBoardAttr: route.query?.fromBoardAttr || '0'
        }),
      },
      {
        path: 'add/:bbsId',
        name: 'BoardInsert',
        meta: { menu: 'board', keepAlive: false },
        component: () => import('@/pages/cmsMng/boardMng/board/BoardInsertContainer.vue'),
        props: (route) => ({
          bbsId: route.params.bbsId || '',
          fromBoardAttr: route.query?.fromBoardAttr || '0'
        }),
      },
      {
        path: 'modify/:bbsId/:pstId',
        name: 'BoardUpdate',
        meta: { menu: 'board', keepAlive: false },
        component: () => import('@/pages/cmsMng/boardMng/board/BoardUpdateContainer.vue'),
        props: (route) => ({
          bbsId: route.params.bbsId || '',
          pstId: route.params.pstId || '',
          fromBoardAttr: route.query?.fromBoardAttr || '0'
        }),
      },
    ]
  },
  {
    path: 'board-attr',
    redirect: { name: 'BoardAttrList' },
    children: [
      // 게시판관리 > 게시판 속성 관리
      {
        path: 'list',
        name: 'BoardAttrList',
        meta: { menu: 'board-attr', keepAlive: true },
        component: () => import('@/pages/cmsMng/boardMng/boardAttr/BoardAttrListView.vue')
      },
      {
        path: 'add',
        name: 'BoardAttrInsert',
        meta: { menu: 'board-attr', keepAlive: false },
        component: () => import('@/pages/cmsMng/boardMng/boardAttr/BoardAttrInsertView.vue')
      },
      {
        path: 'modify/:bbsId',
        name: 'BoardAttrUpdate',
        meta: { menu: 'board-attr', keepAlive: false },
        component: () => import('@/pages/cmsMng/boardMng/boardAttr/BoardAttrUpdateView.vue'),
        props: true,
      },
    ]
  },
]

export default routes


